/* ── AR LOGIC & SHADES ─────────────────────────────────────────────────── */
const SHADES = {
  rose:     { name: 'Rose',     ar: '#8a3227', hex: '#89382E', desc: 'Výrazná červenorůžová — jeden nátěr, intenzivní barva.' },
  camellia: { name: 'Camellia', ar: '#C47275', hex: '#B97D75', desc: 'Teplý růžovo-béžový odstín pro přirozený, každodenní vzhled.' },
  echium:   { name: 'Echium',   ar: '#3f000f', hex: '#985E5E', desc: 'Hluboká vínová s chladným podtónem pro sofistikovaný večer.' },
  almond:   { name: 'Almond',   ar: '#B36D5B', hex: '#D6886B', desc: 'Teplá karamelově hnědá — přirozený nude tón s hřejivým podtónem.' },
};

const OUTER_LIPS = [61,185,40,39,37,0,267,269,270,409,291,375,321,405,314,17,84,181,91,146];
const INNER_LIPS = [78,191,80,81,82,13,312,311,310,415,308,324,318,402,317,14,87,178,88,95];

let arActive = false, arShade = null, faceMesh = null, arCamera = null;
let arVideo = null, arCanvas = null, arCtx = null;

function initARMirror() {
  arVideo  = document.getElementById('ar-video');
  arCanvas = document.getElementById('ar-canvas');
  if (arCanvas) arCtx = arCanvas.getContext('2d');
  buildModalShades();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initARMirror);
} else {
  initARMirror();
}

function buildModalShades() {
  const container = document.getElementById('modal-shades');
  if (!container) return;

  container.innerHTML = Object.entries(SHADES).map(([id, s]) => `
    <button id="msbtn-${id}" onclick="pickShade('${id}')"
      class="modal-shade-btn"
      type="button"
      style="display:flex;align-items:center;gap:1.2rem;padding:1.2rem;
             border:0.1rem solid rgba(18,18,18,0.15);background:transparent;
             text-align:left;cursor:pointer;width:100%;transition:border-color .2s,background .2s;font-family:inherit;">
      <span class="shade-swatch" style="width:3rem;height:3rem;border-radius:50%;flex-shrink:0;display:block;background:${s.hex};"></span>
      <div>
        <p style="font-family:'Amiri',serif;font-size:1.4rem;line-height:1.2;margin:0;">${s.name}</p>
        <p class="shade-desc" style="font-size:1.1rem;color:rgba(18,18,18,0.5);font-family:-apple-system,sans-serif;margin:0;">${s.desc.split('—')[0].trim()}</p>
      </div>
    </button>`).join('');
}

let selectedVariantId = null;

function pickShade(id) {
  arShade = SHADES[id];
  
  // 1. Vizuální změny - reset a aktivace tlačítka odstínu
  document.querySelectorAll('.modal-shade-btn').forEach(b => {
    b.style.borderColor = 'rgba(18,18,18,0.15)';
    b.style.background = 'transparent';
  });

  const btn = document.getElementById('msbtn-' + id);
  if (btn) {
    btn.style.borderColor = 'rgb(18,18,18)';
    btn.style.background = '#fff';
  }

  // 2. Aktualizace názvu a popisu
  const nameEl = document.getElementById('modal-shade-name');
  if (nameEl) {
    nameEl.textContent = arShade.name;
    nameEl.style.color = arShade.hex;
  }

  const descEl = document.getElementById('modal-shade-desc');
  if (descEl) descEl.textContent = arShade.desc;

  // 3. Spárování s reálnou variantou v Shopify a aktualizace ceny
  const priceEl = document.getElementById('modal-price');
  const addBtn = document.getElementById('modal-add-btn');
  selectedVariantId = null; // Reset před hledáním

  if (window.SHOPIFY_PRODUCT && window.SHOPIFY_PRODUCT.variants) {
    // Hledáme variantu, jejíž název (title) nebo interní název (name) obsahuje jméno našeho odstínu
    const matchedVariant = window.SHOPIFY_PRODUCT.variants.find(v => 
      v.title.toLowerCase().includes(arShade.name.toLowerCase()) || 
      v.name.toLowerCase().includes(arShade.name.toLowerCase())
    );

    if (matchedVariant) {
      selectedVariantId = matchedVariant.id;
      
      // Cena je v haléřích/centech, proto dělíme 100
const activeCurrency = window.Shopify?.currency?.active || 'CZK';
const activeLocale = document.documentElement.lang || 'cs-CZ';

const formattedPrice = new Intl.NumberFormat(activeLocale, {
  style: 'currency',
  currency: activeCurrency,
  currencyDisplay: 'symbol',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
}).format(Number(matchedVariant.price) / 100);

if (priceEl) priceEl.textContent = formattedPrice;

      
      // Pokud je varianta dostupná (má nastaveno ID), povolíme tlačítko
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.style.opacity = '1';
        addBtn.textContent = 'Tu chci — přidat do košíku';
      }
    } else {
      // Pokud varianta neexistuje (např. Almond)
      if (priceEl) priceEl.textContent = 'Nedostupné';
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.style.opacity = '0.3';
        addBtn.textContent = 'Tento odstín se připravuje';
      }
    }
  } else {
     // Pokud se nenačtou data ze Shopify (např. chyba v Liquid), fallback vizuál
     if (priceEl) priceEl.textContent = 'Cena nedostupná';
     if (addBtn) addBtn.disabled = true;
  }
}

function addFromModal() {
  if (!selectedVariantId) return;

  const btn = document.getElementById('modal-add-btn');
  const orig = btn.textContent;
  
  // Vizuální zpětná vazba, že se něco děje
  btn.disabled = true;
  btn.textContent = 'Přidávám...';
  btn.style.opacity = '0.7';

  // Volání oficiálního Shopify AJAX API pro přidání do košíku
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: selectedVariantId,
      quantity: 1
    })
  })
  .then(res => {
      if (!res.ok) {
          throw new Error('Chyba při komunikaci se serverem');
      }
      return res.json();
  })
  .then(() => {
    // Úspěch!
    btn.textContent = '✓ Přidáno do košíku';
    btn.style.background = '#166534';
    btn.style.opacity = '1';

    // Pokus o aktualizaci počítadla košíku v šabloně (Dawn šablona)
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const bubble = document.querySelector('.cart-count-bubble');
        if (bubble) {
            const span = bubble.querySelector('span:first-child') || bubble;
            span.textContent = cart.item_count;
            bubble.classList.remove('hidden'); 
        }
      });

    // Návrat tlačítka do původního stavu
    setTimeout(() => { 
      btn.textContent = orig; 
      btn.style.background = 'rgb(18,18,18)';
      btn.disabled = false;
    }, 2000);
  })
  .catch(err => {
    console.error('Chyba při vkládání do košíku:', err);
    btn.textContent = 'Chyba, zkuste to znovu';
    btn.style.background = '#B91C1C'; // Červená pro chybu
    btn.style.opacity = '1';
    
    setTimeout(() => { 
      btn.textContent = orig; 
      btn.style.background = 'rgb(18,18,18)';
      btn.disabled = false;
    }, 3000);
  });
}

function openArModal() {
  const modal = document.getElementById('ar-modal');
  if (!modal) return;

  // Přesun modalu přímo do <body>, aby position:fixed fungoval správně
  // (Dawn animace používají transform, který rozbíjí fixed positioning)
  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  modal.style.visibility = 'visible';
  modal.style.opacity = '1';
  document.body.style.overflow = 'hidden';

  buildModalShades();
  if (!arActive) startAR();
}


function closeArModal() {
  const modal = document.getElementById('ar-modal');
  if (!modal) return;
  modal.style.visibility = 'hidden';
  modal.style.opacity = '0';
  document.body.style.overflow = '';
}

function handleModalBgClick(e) {
  if (e.target === document.getElementById('ar-modal')) closeArModal();
}

function startAR() {
  if (!arVideo || !arCanvas) {
    arVideo  = document.getElementById('ar-video');
    arCanvas = document.getElementById('ar-canvas');
    if (arCanvas) arCtx = arCanvas.getContext('2d');
  }

  arActive = true;
  faceMesh = new FaceMesh({ locateFile: f => `https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/${f}` });
  faceMesh.setOptions({ maxNumFaces: 1, refineLandmarks: true, minDetectionConfidence: 0.5, minTrackingConfidence: 0.5 });
  faceMesh.onResults(onResults);

  arCamera = new Camera(arVideo, {
    onFrame: async () => { 
      if (faceMesh && arVideo) await faceMesh.send({ image: arVideo }); 
    },
    width: 640, 
    height: 480,
  });
  arCamera.start().catch(() => console.warn('Kamera nedostupná'));
}

function sampleLipBrightness(lm, w, h) {
  const pts = [13, 14, 17, 0, 61, 291, 78, 308];
  let sum = 0;
  for (const idx of pts) {
    const px = Math.round(lm[idx].x * w);
    const py = Math.round(lm[idx].y * h);
    if (px < 0 || px >= w || py < 0 || py >= h) continue;
    const d = arCtx.getImageData(px, py, 1, 1).data;
    sum += (0.299 * d[0] + 0.587 * d[1] + 0.114 * d[2]) / 255;
  }
  return sum / pts.length;
}

let _lipOff1 = null, _lipOff2 = null;

function makeLipMask(lm, w, h, alphaHex, isSecond) {
  if (!_lipOff1 || _lipOff1.width !== w) {
    _lipOff1 = new OffscreenCanvas(w, h);
    _lipOff2 = new OffscreenCanvas(w, h);
  }
  const off = isSecond ? _lipOff2 : _lipOff1;
  const ctx = off.getContext('2d');
  ctx.clearRect(0, 0, w, h);
  ctx.filter = 'blur(3px)';
  ctx.fillStyle = arShade.ar + alphaHex;
  ctx.beginPath();
  ctx.moveTo(lm[OUTER_LIPS[0]].x * w, lm[OUTER_LIPS[0]].y * h);
  for (let i = 1; i < OUTER_LIPS.length; i++) ctx.lineTo(lm[OUTER_LIPS[i]].x * w, lm[OUTER_LIPS[i]].y * h);
  ctx.closePath();
  ctx.fill();
  ctx.filter = 'none';
  ctx.globalCompositeOperation = 'destination-out';
  ctx.fillStyle = 'rgba(0,0,0,1)';
  ctx.beginPath();
  ctx.moveTo(lm[INNER_LIPS[0]].x * w, lm[INNER_LIPS[0]].y * h);
  for (let i = 1; i < INNER_LIPS.length; i++) ctx.lineTo(lm[INNER_LIPS[i]].x * w, lm[INNER_LIPS[i]].y * h);
  ctx.closePath();
  ctx.fill();
  ctx.globalCompositeOperation = 'source-over';
  return off;
}

function onResults(r) {
  const mirrorLogo = document.getElementById('ar-mirror-logo');
  if (mirrorLogo && mirrorLogo.style.display !== 'none') {
    mirrorLogo.style.transition = 'opacity .5s';
    mirrorLogo.style.opacity = '0';
    setTimeout(() => { mirrorLogo.style.display = 'none'; }, 500);
  }

  if (!arCanvas || !arVideo) return;

  if (arCanvas.width !== arVideo.videoWidth) {
    arCanvas.width  = arVideo.videoWidth;
    arCanvas.height = arVideo.videoHeight;
  }

  arCtx.save();
  arCtx.clearRect(0, 0, arCanvas.width, arCanvas.height);
  arCtx.drawImage(r.image, 0, 0, arCanvas.width, arCanvas.height);

  if (arShade && r.multiFaceLandmarks && r.multiFaceLandmarks.length) {
    const lm = r.multiFaceLandmarks[0];
    const w  = arCanvas.width;
    const h  = arCanvas.height;

    const brightness = sampleLipBrightness(lm, w, h);
    const dark   = brightness < 0.30;
    const bright = brightness > 0.65;
    
    const a1 = dark ? 0.10 : bright ? 0.20 : 0.15;
    const a2 = dark ? 0.45 : bright ? 0.70 : 0.55;
    const a3 = dark ? 0.70 : bright ? 0.50 : 0.60;

    const h1 = Math.round(a1 * 255).toString(16).padStart(2, '0');
    const h2 = Math.round(a2 * 255).toString(16).padStart(2, '0');
    const h3 = Math.round(a3 * 255).toString(16).padStart(2, '0');

    arCtx.globalCompositeOperation = 'soft-light';
    arCtx.drawImage(makeLipMask(lm, w, h, h3, false), 0, 0);
    
    arCtx.globalCompositeOperation = 'color';
    arCtx.drawImage(makeLipMask(lm, w, h, h2, true), 0, 0);
    
    arCtx.globalCompositeOperation = 'source-over';
    arCtx.drawImage(makeLipMask(lm, w, h, h1, true), 0, 0);
    
    arCtx.globalCompositeOperation = 'source-over';
  }

  arCtx.restore();
}